export function removeDiacritics(string: string) {
	return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function tokenize(string: string = '') {
	return removeDiacritics(string.toLowerCase());
}

// based on backend seoize function https://gitlab.seznam.net/sbazar/backend/-/blob/master/common/utils/__init__.py
export function getSeoName(string: string = '') {
	let seoName = tokenize(string.trim());

	// prevede "-", "+", "´" a prazdny znak včetně opakujících se výskytů na "-"
	seoName = seoName.replace(/[-+\s´]+/g, '-');

	// smaze vse krome alpha-numeric, +, - znaků
	return seoName.replace(/[^\w\s-]/g, '');
}
